module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("在部分用户看来这是一个使用门槛，实际上它本意是为了让用户更方便地开发。")]), _vm._v(" "), _c('p', [_vm._v("它是为了实现按需引用组件及定义 less 变量以及编译时优化代码而开发的，并不会造在配置上的麻烦，具体使用时仅仅是需要调用 "), _c('code', [_vm._v("merge")]), _vm._v(" 方法合并原有 webpack 配置。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c72c17b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-c72c17b4"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-using-vux-loader-28.vue
// module id = 2441
// module chunks = 174